import React, { useContext } from 'react'
import DocumentAuthorContext from '../../../../../context/DocumentAuthorContext';

export default function CheckBox({component}){
    const { componentAnswers } = useContext(DocumentAuthorContext);
    return (
        <div className={`${component.label.alignment === 'top' ? 'flex flex-col' : 'flex items-start'} cursor-default`} style={{ minWidth: "150px", width: component.styles.width }}>
            {component.label.name.trim() !== '' && 
            <div className='min-w-[120px] mr-[10px]'>
                <label style={component?.label?.styles} className={`text-[#333]
                     cursor-default pr-2 break-all`}>{component.label.name || ''} {component.is_required && <span data-testid="is_required"  className='text-[#333]'>*</span>}</label>
            </div>}
            <div className={`${component.label.alignment === 'top' ? 'mt-4' : 'mt-1.5'} ${component.styles.labelAlignment === 'left' ? 'flex items-start gap-[16px] flex-wrap' : ''}`}>
                {component.fields.map((data, index) => (
                    <div key={`${component.component_id}-${index}`} style={component.fields.length - 1 !== index ? {paddingBottom: '10px'} : {}} className='flex items-start leading-none gap-2 h-[30px] custom-checkbox4 form-checkbox relative'>
                        <input
                            type="checkbox"
                            id={`checkbox_${index}_${component.id}`}
                            checked={component.values.includes(data.value) || (componentAnswers[component.component_id] ? componentAnswers[component.component_id].includes(data.value) : '')}
                            value={data.value}
                            disabled
                            className='cursor-pointer forms-authoring-checkbox'
                            data-testid={`checkbox_${index}_${component.id}`} />
                        <label style={{fontSize: component?.styles?.labelFontSize, overflowWrap: 'anywhere'}} className={`text-base -mt-[3px] text-[#333] ml-[8px] font-normal`} 
                            htmlFor={`checkbox_${index}_${component.id}`}>{(component.show_label === true) ? data.label : ''}</label>
                    </div>
                ))}
            </div>
        </div>
    )
} 